<template>
  <div class="vc-clone-steps-root">
    <div class="vc-clone-steps">
      <div class="vc-step-line">
        <div
          v-for="(s, i) in cloneStepLabels"
          :key="'clone-step-' + i"
          class="vc-step-chunk"
        >
          <div class="vc-step-item">
            <span class="vc-step-dot" :class="cloneStepClass(i)">
              <Icon v-if="cloneStep > i" type="ios-checkmark" size="18" />
              <template v-else>{{ i + 1 }}</template>
            </span>
            <span class="vc-step-text" :class="{ 'vc-step-text--active': cloneStep === i }">{{ s }}</span>
          </div>
          <div
            v-if="i < cloneStepLabels.length - 1"
            class="vc-step-seg"
            :class="{ 'vc-step-seg--done': cloneStep > i }"
          />
        </div>
      </div>

      <div v-show="cloneStep === 0" class="vc-clone-body">
        <div class="vc-clone-basic-row">
          <div class="vc-clone-field vc-clone-field--name">
            <span class="vc-form-label vc-form-label--required">音色名称</span>
            <Input v-model="cloneForm.name" placeholder="请输入音色名称" :maxlength="40" />
          </div>
          <div class="vc-clone-field vc-clone-field--gender">
            <span class="vc-form-label vc-form-label--required">性别</span>
            <Select v-model="cloneForm.gender" transfer placeholder="请选择">
              <Option
                v-for="item in genderOptions"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </Option>
            </Select>
          </div>
        </div>
        <div class="vc-clone-field">
          <span class="vc-form-label vc-form-label--required">选择引擎</span>
          <div class="vc-engine-cards vc-engine-cards--modal">
            <div
              v-if="showAliyunCloneEngines"
              class="vc-engine-card"
              :class="{ 'vc-engine-card--active': cloneForm.engine === VOICE_ENGINE.ALIYUN }"
              @click="cloneForm.engine = VOICE_ENGINE.ALIYUN"
            >
              <div class="vc-engine-card__main">
                <span class="vc-engine-card__logo vc-engine-card__logo--ali">阿里</span>
                <div class="vc-engine-card__text">
                  <div class="vc-engine-card__title-row">
                    <div class="vc-engine-card__title-group">
                      <span class="vc-engine-card__title">千问全模态3.5-Omni</span>
                      <span v-if="cloneForm.engine === VOICE_ENGINE.ALIYUN" class="vc-engine-card__picked">已选</span>
                    </div>
                    <span
                      class="vc-fake-radio"
                      :class="{ 'vc-fake-radio--on': cloneForm.engine === VOICE_ENGINE.ALIYUN }"
                    />
                  </div>
                  <p class="vc-engine-card__desc">基于达摩院语音技术，支持多种音色选择，音质自然流畅，延迟低</p>
                </div>
              </div>
            </div>
            <div
              v-if="showAliyunCloneEngines"
              class="vc-engine-card"
              :class="{ 'vc-engine-card--active': cloneForm.engine === VOICE_ENGINE.QWEN_OMNI }"
              @click="cloneForm.engine = VOICE_ENGINE.QWEN_OMNI"
            >
              <div class="vc-engine-card__main">
                <span class="vc-engine-card__logo vc-engine-card__logo--qwen">阿里</span>
                <div class="vc-engine-card__text">
                  <div class="vc-engine-card__title-row">
                    <div class="vc-engine-card__title-group">
                      <span class="vc-engine-card__title">千问实时语音Audio3.0-Plus</span>
                      <span v-if="cloneForm.engine === VOICE_ENGINE.QWEN_OMNI" class="vc-engine-card__picked">已选</span>
                    </div>
                    <span
                      class="vc-fake-radio"
                      :class="{ 'vc-fake-radio--on': cloneForm.engine === VOICE_ENGINE.QWEN_OMNI }"
                    />
                  </div>
                  <p class="vc-engine-card__desc">延迟最低，适合业务链条短的场景</p>
                </div>
              </div>
            </div>
            <div
              v-if="showTripleCloneEngine"
              class="vc-engine-card"
              :class="{ 'vc-engine-card--active': cloneForm.engine === VOICE_ENGINE.TRIPLE }"
              @click="cloneForm.engine = VOICE_ENGINE.TRIPLE"
            >
              <div class="vc-engine-card__main">
                <span class="vc-engine-card__logo vc-engine-card__logo--triple">级联</span>
                <div class="vc-engine-card__text">
                  <div class="vc-engine-card__title-row">
                    <div class="vc-engine-card__title-group">
                      <span class="vc-engine-card__title">{{ tripleCloneEngineLabel }}</span>
                      <span v-if="cloneForm.engine === VOICE_ENGINE.TRIPLE" class="vc-engine-card__picked">已选</span>
                    </div>
                    <span
                      class="vc-fake-radio"
                      :class="{ 'vc-fake-radio--on': cloneForm.engine === VOICE_ENGINE.TRIPLE }"
                    />
                  </div>
                  <p class="vc-engine-card__desc">基于{{ tripleCloneEngineLabel }}克隆音色</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="vc-clone-field">
          <span class="vc-form-label vc-form-label--required">上传录音</span>
          <Upload
            :before-upload="handleUploadSample"
            :show-upload-list="false"
            multiple
            accept=".wav,.mp3,audio/wav,audio/mpeg"
            :action="uploadA"
          >
            <div class="vc-upload-zone">
              <Icon type="ios-cloud-upload" size="36" color="#8c8c8c" />
              <p class="vc-upload-tip">点击上传音频文件</p>
              <p class="vc-upload-sub">支持 WAV/MP3 格式，单文件 ≤10MB，最多10段</p>
            </div>
          </Upload>
          <div v-if="cloneForm.files.length" class="vc-upload-files">
            <div v-for="(f, fi) in cloneForm.files" :key="fi" class="vc-upload-file-row">
              <Icon type="ios-musical-notes" size="18" />
              <span class="vc-upload-file-name">{{ f.name }}</span>
              <span class="vc-upload-file-size">{{ formatFileSize(f.size) }}</span>
              <Icon type="ios-close" class="vc-upload-file-remove" @click="removeCloneFile(fi)" />
            </div>
          </div>
        </div>
        <div class="vc-agree-box">
          <Checkbox v-model="cloneForm.agreement">
            我确认拥有上传音频的合法使用权或已获得权利人授权，知晓未经授权克隆他人声音可能带来的法律风险。
          </Checkbox>
        </div>
        <div class="vc-clone-footer">
          <Button @click="close">取消</Button>
          <Button
            type="primary"
            :disabled="!canStartClone || cloneSubmitting"
            :loading="cloneSubmitting"
            @click="startCloneProcess"
          >开始克隆</Button>
        </div>
      </div>

      <div v-show="cloneStep === 1" class="vc-clone-body vc-clone-body--center">
        <Progress :percent="cloneProgress" :stroke-width="8" />
        <p class="vc-clone-progress-num">{{ cloneProgress }}%</p>
        <p class="vc-clone-status-msg">{{ cloneStatusMsg }}</p>
        <Button type="text" @click="cancelCloneProgress">取消</Button>
      </div>

      <div v-show="cloneStep === 2" class="vc-clone-body">
        <div class="vc-clone-success">
          <span class="vc-success-icon"><Icon type="ios-checkmark-circle" size="56" color="#19be6b" /></span>
          <div class="vc-success-title">克隆成功</div>
        </div>
        <div v-if="showCloneAuditionUi" class="vc-clone-field">
          <span class="vc-form-label">输入试听内容</span>
          <div class="vc-audit-row">
            <Button type="primary" size="small" ghost @click="playAudition">
              <Icon type="ios-play" /> 试听
            </Button>
          </div>
          <Input v-model="cloneAuditionText" type="textarea" :rows="4" :maxlength="500" />
        </div>
        <div class="vc-clone-footer">
          <Button @click="restartCloneWizard">重新克隆</Button>
          <Button type="primary" @click="saveClonedVoice">保存</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import service from '@/utils/request'
import { uploadA, getUploadTokenA, sceneLlmCopyVoiceA } from '@/server/api'
import { getToken } from '@/utils/auth'
import {
  VOICE_ENGINE,
  CLONE_VOICE_TYPE_LABEL,
  getCloneVendor,
  TRIPLE_CLONE_VENDOR,
} from '../../constants/voicePresets'
import { toPublicAudioUrl } from './voiceAudioUtils'
import { PRESET_MODE, resolveCopyVoicePathFromLlm, resolveFlagshipCatalogEntryFromLlm } from '../../utils/tripleAccessHelpers'

const COPY_VOICE_HTTP_TIMEOUT_MS = 120000
const CLONE_PROGRESS_CAP = 92
const CLONE_PROGRESS_INTERVAL_MS = 350
const CLONE_PROGRESS_FINISH_MS = 500

export default {
  name: 'CloneVoiceWizard',
  props: {
    voiceCall: {
      type: Object,
      required: true,
    },
    maxMyVoices: {
      type: Number,
      default: 5,
    },
    embedded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      VOICE_ENGINE,
      cloneVoiceTypeLabels: CLONE_VOICE_TYPE_LABEL,
      uploadA,
      cloneStepLabels: ['克隆配置', '克隆进行中', '克隆结果'],
      genderOptions: [
        { value: 'female', label: '女' },
        { value: 'male', label: '男' },
      ],
      cloneStep: 0,
      cloneProgress: 0,
      cloneStatusMsg: '正在分析声纹特征…',
      cloneProgressTimer: null,
      cloneSubmitting: false,
      cloneResultVoiceId: '',
      cloneResultVendor: '',
      cloneForm: {
        name: '',
        gender: 'female',
        engine: VOICE_ENGINE.ALIYUN,
        files: [],
        agreement: false,
      },
      cloneAuditionText: '您好，我是您的新克隆音色，感谢您的使用！',
      showCloneAuditionUi: false,
    }
  },
  computed: {
    canStartClone() {
      const n = String(this.cloneForm.name || '').trim()
      if (!n) return false
      if (!this.cloneForm.gender) return false
      if (!this.cloneForm.agreement) return false
      if (!this.cloneForm.files.length) return false
      return true
    },
    isTripleCloneEngine() {
      return this.cloneForm.engine === VOICE_ENGINE.TRIPLE
    },
    isFlagshipMode() {
      return (this.voiceCall.presetMode || PRESET_MODE.ENGINE) === PRESET_MODE.CUSTOM
    },
    showAliyunCloneEngines() {
      return !this.isFlagshipMode
    },
    showTripleCloneEngine() {
      return this.isFlagshipMode
    },
    tripleCloneEngineLabel() {
      const entry = resolveFlagshipCatalogEntryFromLlm(
        this.voiceCall.tripleAccess && this.voiceCall.tripleAccess.llm,
      )
      return (entry && entry.label) || this.cloneVoiceTypeLabels[VOICE_ENGINE.TRIPLE]
    },
  },
  watch: {
    'voiceCall.presetMode'() {
      this.syncCloneEngineForPresetMode()
    },
  },
  beforeDestroy() {
    this.clearCloneTimer()
  },
  mounted() {
    this.syncCloneEngineForPresetMode()
    if (this.embedded) {
      this.resetCloneWizard(false)
    }
  },
  methods: {
    syncCloneEngineForPresetMode() {
      const allowed = this.isFlagshipMode
        ? [VOICE_ENGINE.TRIPLE]
        : [VOICE_ENGINE.ALIYUN, VOICE_ENGINE.QWEN_OMNI]
      if (allowed.includes(this.cloneForm.engine)) return
      this.cloneForm.engine = allowed[0]
    },
    defaultCloneEngineForPresetMode() {
      return this.isFlagshipMode ? VOICE_ENGINE.TRIPLE : VOICE_ENGINE.ALIYUN
    },
    close() {
      if (this.embedded) {
        this.resetCloneWizard(false)
        this.$emit('cancel')
        return
      }
      this.$emit('cancel')
    },
    resetCloneWizard(full) {
      this.cloneStep = 0
      this.cloneProgress = 0
      this.cloneForm = {
        name: '',
        gender: 'female',
        engine: this.defaultCloneEngineForPresetMode(),
        files: [],
        agreement: false,
      }
      this.syncCloneEngineForPresetMode()
      if (full) this.cloneAuditionText = '您好，我是您的新克隆音色，感谢您的使用！'
      this.cloneResultVoiceId = ''
      this.cloneResultVendor = ''
      this.cloneSubmitting = false
    },
    preventUploadComponentPost() {
      return Promise.reject()
    },
    async handleUploadSample(file) {
      const maxBytes = 10 * 1024 * 1024
      if (file.size > maxBytes) {
        this.$Message.warning('单文件不能超过 10MB')
        return false
      }
      if (this.cloneForm.files.length >= 10) {
        this.$Message.warning('最多上传 10 段音频')
        return false
      }

      let loadingDestroy
      if (this.$Message.loading) {
        loadingDestroy = this.$Message.loading({
          content: '上传中…',
          duration: 0,
        })
      }

      try {
        const tokenRes = await getUploadTokenA()
        if (!tokenRes || tokenRes.code !== 200) {
          this.$Message.error((tokenRes && tokenRes.message) || '获取上传凭证失败')
          return this.preventUploadComponentPost()
        }
        const payload = tokenRes.data || {}
        const uploadToken = payload.uploadToken || payload.upload_token
        if (!uploadToken) {
          this.$Message.error('上传凭证无效')
          return this.preventUploadComponentPost()
        }

        const formData = new FormData()
        formData.append('file', file)
        formData.append('token', uploadToken)

        const uploadRes = await service.post(uploadA, formData, {
          headers: {
            Authorization: getToken() || '',
          },
          autoMsg: false,
        })

        if (!uploadRes || uploadRes.code !== 200) {
          this.$Message.error((uploadRes && uploadRes.message) || '上传失败')
          return this.preventUploadComponentPost()
        }

        const ur = uploadRes.data || {}
        const remoteKey =
          ur.key ||
          ur.Key ||
          ur.filepath ||
          ur.filePath ||
          ur.file_path ||
          ''
        const rawAudioPath =
          (typeof ur.filepath === 'string' && ur.filepath) ||
          (typeof ur.filePath === 'string' && ur.filePath) ||
          (typeof ur.url === 'string' && ur.url) ||
          (remoteKey && /^https?:\/\//i.test(String(remoteKey)) ? String(remoteKey) : '') ||
          (remoteKey ? String(remoteKey) : '')
        const audioFilePath = toPublicAudioUrl(rawAudioPath)

        this.cloneForm.files.push({
          name: file.name,
          size: file.size,
          key: remoteKey,
          audioFilePath,
          raw: file,
        })
        this.$Message.success('上传成功')
      } catch (e) {
        this.$Message.error('上传失败')
      } finally {
        if (typeof loadingDestroy === 'function') loadingDestroy()
      }
      return this.preventUploadComponentPost()
    },
    removeCloneFile(index) {
      this.cloneForm.files.splice(index, 1)
    },
    formatFileSize(n) {
      if (n >= 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(1)}MB`
      if (n >= 1024) return `${(n / 1024).toFixed(1)}KB`
      return `${n}B`
    },
    clearCloneTimer() {
      if (this.cloneProgressTimer) {
        clearInterval(this.cloneProgressTimer)
        this.cloneProgressTimer = null
      }
    },
    cloneStepClass(i) {
      if (this.cloneStep > i) return 'vc-step-dot--done'
      if (this.cloneStep === i) return 'vc-step-dot--active'
      return 'vc-step-dot--wait'
    },
    startCloneProgressAnimation() {
      this.clearCloneTimer()
      this.cloneProgress = 0
      this.cloneStatusMsg = '正在分析音频…'
      let tick = 0
      this.cloneProgressTimer = setInterval(() => {
        tick += 1
        const next = CLONE_PROGRESS_CAP * (1 - Math.exp(-tick / 22))
        this.cloneProgress = Math.min(CLONE_PROGRESS_CAP, Math.round(next))
        if (this.cloneProgress >= 25) this.cloneStatusMsg = '正在分析声纹特征…'
        if (this.cloneProgress >= 55) this.cloneStatusMsg = '正在生成克隆音色…'
        if (this.cloneProgress >= CLONE_PROGRESS_CAP - 2) {
          this.cloneStatusMsg = '即将完成，请稍候…'
        }
      }, CLONE_PROGRESS_INTERVAL_MS)
    },
    finishCloneProgress() {
      return new Promise((resolve) => {
        this.clearCloneTimer()
        const from = this.cloneProgress
        const startAt = Date.now()
        this.cloneProgressTimer = setInterval(() => {
          const ratio = Math.min(1, (Date.now() - startAt) / CLONE_PROGRESS_FINISH_MS)
          const eased = 1 - (1 - ratio) * (1 - ratio)
          this.cloneProgress = Math.min(100, Math.round(from + (100 - from) * eased))
          if (ratio >= 1) {
            this.clearCloneTimer()
            this.cloneProgress = 100
            resolve()
          }
        }, 40)
      })
    },
    engineToCopyVoiceVendor(engine) {
      return getCloneVendor(engine)
    },
    buildCopyVoicePayload(audioPath) {
      const audioFileName = String(this.cloneForm.name || '').trim()
      return {
        vendor: this.isTripleCloneEngine
          ? TRIPLE_CLONE_VENDOR
          : this.engineToCopyVoiceVendor(this.cloneForm.engine),
        audio_file_path: String(audioPath).trim(),
        audio_file_name: audioFileName,
      }
    },
    async startCloneProcess() {
      const files = this.cloneForm.files || []
      if (!files.length) {
        this.$Message.warning('请先上传音频')
        return
      }
      const first = files[0]
      const audioPath = toPublicAudioUrl(
        (first && first.audioFilePath) || (first && first.key) || '',
      )
      if (!String(audioPath).trim()) {
        this.$Message.warning('音频地址无效，请重新上传')
        return
      }

      this.cloneSubmitting = true
      this.cloneStep = 1
      this.startCloneProgressAnimation()

      try {
        const res = await sceneLlmCopyVoiceA(
          this.buildCopyVoicePayload(audioPath),
          {
            autoMsg: false,
            timeout: COPY_VOICE_HTTP_TIMEOUT_MS,
          },
          this.isTripleCloneEngine
            ? resolveCopyVoicePathFromLlm(this.voiceCall.tripleAccess && this.voiceCall.tripleAccess.llm)
            : '',
        )
        if (!res || res.code !== 200) {
          this.clearCloneTimer()
          this.$Message.error((res && res.message) || '克隆失败')
          this.cloneStep = 0
          this.cloneProgress = 0
          return
        }
        const d = res.data || {}
        this.cloneResultVoiceId =
          d.voice_id != null ? String(d.voice_id) : d.voiceId != null ? String(d.voiceId) : ''
        this.cloneResultVendor = d.vendor != null ? String(d.vendor).trim() : ''
        await this.finishCloneProgress()
        this.cloneStatusMsg = '克隆完成'
        this.cloneStep = 2
      } catch (e) {
        this.clearCloneTimer()
        const aborted = e && (e.code === 'ECONNABORTED' || /timeout/i.test(String(e.message || '')))
        this.$Message.error(
          aborted ? '克隆请求超时（浏览器等待过久），请稍后重试' : '克隆请求失败',
        )
        this.cloneStep = 0
        this.cloneProgress = 0
      } finally {
        this.cloneSubmitting = false
      }
    },
    cancelCloneProgress() {
      this.clearCloneTimer()
      this.cloneSubmitting = false
      this.cloneStep = 0
      this.cloneProgress = 0
    },
    saveClonedVoice() {
      const voiceId =
        (this.cloneResultVoiceId && String(this.cloneResultVoiceId).trim()) ||
        `cv_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`
      const name = String(this.cloneForm.name || '').trim() || '未命名音色'
      if (!Array.isArray(this.voiceCall.clonedVoices)) {
        this.$set(this.voiceCall, 'clonedVoices', [])
      }
      if (this.voiceCall.clonedVoices.length >= this.maxMyVoices) {
        this.$Message.warning(`最多保存 ${this.maxMyVoices} 个音色`)
        return
      }
      const vendorRaw =
        (this.cloneResultVendor && String(this.cloneResultVendor).trim()) ||
        (this.isTripleCloneEngine
          ? TRIPLE_CLONE_VENDOR
          : this.engineToCopyVoiceVendor(this.cloneForm.engine))
      const files = this.cloneForm.files || []
      const first = files[0]
      let audioPath = ''
      if (first) {
        audioPath =
          (first.audioFilePath && String(first.audioFilePath).trim()) ||
          (first.key ? toPublicAudioUrl(String(first.key)) : '') ||
          ''
        audioPath = String(audioPath).trim()
      }
      this.voiceCall.clonedVoices.push({
        voice_id: voiceId,
        name,
        vendor: vendorRaw,
        audio_file_path: audioPath || '',
        audio_file_name: name,
        gender: this.cloneForm.gender || 'female',
        ...(this.isTripleCloneEngine
          ? {
              product_line: String(
                (
                  resolveFlagshipCatalogEntryFromLlm(
                    this.voiceCall.tripleAccess && this.voiceCall.tripleAccess.llm,
                  ) || {}
                ).productLine || '',
              ),
            }
          : {}),
      })
      this.resetCloneWizard(true)
      this.$emit('saved')
    },
    restartCloneWizard() {
      this.resetCloneWizard(true)
      this.cloneStep = 0
    },
    playAudition() {
      this.$Message.info('试听：' + String(this.cloneAuditionText || '').slice(0, 40) + '…')
    },
  },
}
</script>

<style lang="scss" scoped>
@import './shared.scss';

.vc-clone-steps-root {
  margin: 0 -4px;
}

.vc-clone-steps {
  padding: 0 4px 8px;
}

.vc-step-line {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 28px;
  padding: 15px 8px 0;
}

.vc-step-chunk {
  display: flex;
  flex: 1;
  align-items: flex-start;
  min-width: 0;
}

.vc-step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.vc-step-dot {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  background: #f5f5f5;
  color: #bfbfbf;
  border: 2px solid #e8eaec;

  &--active {
    background: #2d8cf0;
    border-color: #2d8cf0;
    color: #fff;
  }

  &--done {
    background: #19be6b;
    border-color: #19be6b;
    color: #fff;
  }

  &--wait {
    background: #fafafa;
  }
}

.vc-step-text {
  font-size: 12px;
  color: #8c8c8c;
  text-align: center;
  line-height: 1.3;

  &--active {
    color: #2d8cf0;
    font-weight: 600;
  }
}

.vc-step-seg {
  flex: 0 0 24px;
  height: 2px;
  margin-top: 14px;
  background: #e8eaec;

  &--done {
    background: #19be6b;
  }
}

.vc-clone-basic-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 18px;

  .vc-clone-field {
    margin-bottom: 0;
  }
}

.vc-clone-field--name {
  flex: 1;
  min-width: 0;
}

.vc-clone-field--gender {
  flex: 0 0 140px;
  width: 140px;
}

.vc-clone-field {
  margin-bottom: 18px;

  ::v-deep .ivu-upload {
    display: block;
    width: 100%;
  }

  ::v-deep .ivu-upload-select {
    display: block;
    width: 100%;
  }
}

.vc-upload-zone {
  width: 100%;
  box-sizing: border-box;
  border: 1px dashed #d9d9d9;
  border-radius: 8px;
  padding: 28px 16px;
  text-align: center;
  cursor: pointer;
  background: #fafafa;
  transition: border-color 0.2s;

  &:hover {
    border-color: #2d8cf0;
  }
}

.vc-upload-tip {
  margin: 10px 0 4px;
  font-size: 14px;
  color: #595959;
}

.vc-upload-sub {
  margin: 0;
  font-size: 12px;
  color: #8c8c8c;
}

.vc-upload-files {
  margin-top: 12px;
}

.vc-upload-file-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  margin-bottom: 8px;
  font-size: 13px;
}

.vc-upload-file-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vc-upload-file-size {
  color: #8c8c8c;
  font-size: 12px;
}

.vc-upload-file-remove {
  cursor: pointer;
  color: #8c8c8c;

  &:hover {
    color: #ed4014;
  }
}

.vc-agree-box {
  width: 100%;
  box-sizing: border-box;
  padding: 12px 14px;
  background: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 6px;
  margin-bottom: 20px;
  font-size: 13px;
  color: #595959;
  line-height: 1.6;
}

.vc-clone-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 8px;
}

.vc-clone-body--center {
  text-align: center;
  padding: 24px 16px 16px;

  .vc-clone-progress-num {
    margin: 12px 0 8px;
    font-size: 18px;
    font-weight: 600;
    color: #262626;
  }

  .vc-clone-status-msg {
    margin: 0 0 16px;
    font-size: 13px;
    color: #8c8c8c;
  }
}

.vc-clone-success {
  text-align: center;
  margin-bottom: 20px;
}

.vc-success-title {
  margin-top: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #262626;
}

.vc-audit-row {
  margin-bottom: 8px;
}
</style>

<style lang="scss">
.vc-clone-modal .ivu-modal-body {
  max-height: 72vh;
  overflow-y: auto;
}
</style>
